import axios from 'axios';
import Vue from 'vue';
import { ACCESS_TOKEN, Cache } from "@/store/mutation-types"
import router from '@/router'  // 添加 router 导入
import store from '@/store'
const baseURL = process.env.VUE_APP_API_BASE_URL;
const userBaseURL = process.env.VUE_APP_USER_API_BASE_URL;

// 创建axios实例的工厂函数
const createAxiosInstance = (url) => {

  const instance = axios.create({
    baseURL: url,
    timeout: 5000
  });

  // 请求拦截器
  instance.interceptors.request.use(
    config => {
      const token = Cache.get(ACCESS_TOKEN);
      // console.log('token:', token)
      if (token) {
        config.headers['X-Access-Token'] = `${token}`;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  // 响应拦截器
  instance.interceptors.response.use(
    response => {
      const { data, status } = response;
      if (status === 200) {
        // console.log('reponse请求成功：', data);
        return data;
      } else if (status == 401) {
        // token失效处理
        handleLogout();
        return Promise.reject(new Error('登录已过期'));
      } else {
        console.error('reponse请求出错：', status);
        return Promise.reject(new Error('请求失败'));
      }

    },
    error => {
      if (error.response && error.response.status === 401) {
        // token失效处理
        handleLogout();
        return Promise.reject(new Error('登录已过期'));
      }
      return Promise.reject(error);
    }
  );
  // 添加统一的登出处理函数
  const handleLogout = () => {
    // 清除本地存储
    Cache.clearAll();
    store.commit('setToken', '')
    store.commit('clearUser')
    store.commit('setUsername', '')
    Vue.prototype.$message.error('登录已过期，请重新登录');
    if (router.currentRoute.path !== '/user/login') {
      Vue.nextTick(() => {
        window.location.href = '/user/login';
      });
    }
  };
  return instance;
};

// 创建实例
const api = createAxiosInstance(baseURL);
const userApi = createAxiosInstance(userBaseURL);

export { api, userApi };
export default api;